<ripple-editor *ngIf="!viewOnly"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [style]="{'height':'320px'}"
  [logKey]="key"
></ripple-editor>

<div *ngIf="viewOnly" class="ui-widget ui-corner-all" [innerHTML]="to.description | safeHTML"></div>
